import context from '@truckdown/components-systems';
import { IPromotionManager, PromotionModel } from '@truckdown/promotions';
import { defineComponent, ref, Ref } from "vue";
import { showMessage } from '../../Utilities/utilities';

interface IData {
    isLoading: Ref<boolean>
};

const getInitialData = function (props: any) {
    return {
        isLoading: ref<boolean>(false)
    } as IData;
}

const getMethods = function (props: any, data: IData, ctx: any) {
    return {
        removeFundsPromotionCancelClick: function (): void {
            ctx.emit(events.cancel);
        },
        removeFundsPromotionSaveClick: async function (): Promise<void> {
            await removeFundsPromotion(data, props, ctx);
        },
        getCurrentBalance: function () {
            return (props.promotion.funds.activeFunds + props.promotion.funds.availableFunds).toFixed(2);
        }
    }
}

const removeFundsPromotion = async function (data: IData, props: any, ctx: any): Promise<void> {
    if (!data.isLoading.value) {
        data.isLoading.value = true;
        try {
            let mgr = await context.getService<IPromotionManager>('IPromotionManager');
            var response = await mgr.removeFunds(props.promotion.id);

            if (!response || response == null) {
                showMessage("Error removing funds from the promotion.", "danger", true, true);
                ctx.emit(events.cancel);
            } else {
                showMessage("Promotion funds were successfully removed.", "success", true, true);
                ctx.emit(events.update, response);
            }
        } catch (err) {
            console.log(err);
        } finally {
            data.isLoading.value = false;
        }
    }
}

const events = {
    update: 'update',
    cancel: 'cancel'
};

export default defineComponent({
    props: {
        promotion: {
            type: Object as () => PromotionModel,
            required: true
        }
    },
    emits: [events.update, events.cancel],
    setup: function (props, ctx) {
        let data = getInitialData(props);
        let methods = getMethods(props, data, ctx);

        return {
            ...data,
            ...methods
        };
    }
});